<template>
  <v-container class="pa-0">

    <v-dialog v-model="dialogJumbotron" scrollable  persistent :overlay="false"
    max-width="500px" transition="dialog-transition" >
    <v-card flat tile >
      <v-card-title >
        {{ dialogJumbotronTitle }} <v-spacer></v-spacer>
        <v-icon @click="closeDialogJumbotron()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-row dense>
            <v-col>

              <div class="mb-3" v-if="jumbotron.id">
                <div v-if="jumbotron.Medium.format =='video'" >
                  <youtube :video-id="trimYoutubeId(jumbotron.Medium.body)" ref="plyr"
                  fitParent ></youtube>
                </div>
                <v-img v-if="jumbotron.Medium.format=='image'"
                :src="ss.apiUrl+'/static/images/'+jumbotron.Medium.user_id+'/thumb/'
                + jumbotron.Medium.body" class="mb-3">
              </v-img>

            </div>
            <div v-else class="mb-3">
              <div v-if="jumbotron.MFormat =='video'">
                <youtube  :video-id="trimYoutubeId(jumbotron.MBody)" ref="plyr" fitParent >
                </youtube>
              </div>
              <v-img class="mb-3" v-if="jumbotron.MFormat=='image'" :src="
              ss.apiUrl+'/static/images/'+jumbotron.MUser_id+'/thumb/'+ jumbotron.MBody">
            </v-img>
          </div>
          <v-switch color="primary" :label="$t('mute_video')" v-model="jumbotron.muted"
          v-if="jumbotron.MFormat=='video' || jumbotron.Medium.format =='video'"></v-switch>

          <v-select
          :items="timeOptions"
          v-model="timeOption"
          :label="$t('time_option')"
          @change="timeOptionsChanged"
          ></v-select>

          <v-row dense>
            <v-col cols="6" v-show="timeOption == 'between'">
              <v-menu v-model="menuStartDate" :close-on-content-click="false"
              :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field  v-model="startDateFormatted"
                :label="$t('start_date')" readonly v-on="on" hide-details class="mb-3">
              </v-text-field>
            </template>
            <v-date-picker no-title v-model="startDate" @input="menuStartDate
            = false" color="primary" :locale="remoteLang"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="6" v-show="timeOption == 'between'">
          <v-menu ref="menuStart" v-model="menuStartTime"
          :close-on-content-click="false" :nudge-right="40"
          :return-value.sync="startTime" transition="scale-transition"
          offset-y max-width="290px" min-width="290px" >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="startTime" readonly v-on="on"
            :label="$t('jb_time')" hide-details class="mb-3"></v-text-field>
          </template>
          <v-time-picker no-title :format="(ss.setting.ampm) ? 'ampm' : '24hr'"
          v-if="menuStartTime" v-model="startTime"
          @click:minute="$refs.menuStart.save(startTime)" color="primary">
        </v-time-picker>
      </v-menu>
    </v-col>

    <v-col cols="6" v-show="timeOption == 'between'">
      <v-menu v-model="menuStopDate" :close-on-content-click="false"
      :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field  v-model="stopDateFormatted"
        :label="$t('stop_date')" readonly v-on="on" hide-details class="mb-3">
      </v-text-field>
    </template>
    <v-date-picker no-title v-model="stopDate"
    @input="menuStopDate = false" color="primary" :locale="remoteLang">
  </v-date-picker>
</v-menu>
</v-col>

<v-col cols="6" v-show="timeOption == 'between'">
  <v-menu ref="menuStop" v-model="menuStopTime" :close-on-content-click="false"
  :nudge-right="40" :return-value.sync="stopTime"
  transition="scale-transition" offset-y max-width="290px" min-width="290px" >
  <template v-slot:activator="{ on }">
    <v-text-field v-model="stopTime" readonly v-on="on"
    :label="$t('jb_time')" hide-details class="mb-3"></v-text-field>
  </template>
  <v-time-picker no-title :format="(ss.setting.ampm) ? 'ampm' : '24hr'"
  v-if="menuStopTime" v-model="stopTime"
  @click:minute="$refs.menuStop.save(stopTime)" color="primary">
</v-time-picker>
</v-menu>
</v-col>

<v-col cols="6">
  <v-text-field :label="$t('jumbotron_duration')"
  v-model.number="jumbotron.duration" hide-details class="mb-3">
</v-text-field>
</v-col>

</v-row>
</v-col>
</v-row>
</v-container>
</v-card-text>
<v-card-actions>
  <v-btn color="primary" @click="save()">{{ dialogJumbotronSaveBtn }}</v-btn>
  <v-spacer></v-spacer>
  <v-btn color="secondary" text @click="closeDialogJumbotron()">
  {{ $t('cancel') }}</v-btn><v-spacer v-if="jumbotron.id"></v-spacer>
  <v-btn v-if="jumbotron.id" color="red" text @click="deleteJumbotron(jumbotron.id)">
  {{ $t('delete') }}</v-btn>
</v-card-actions>

</v-card>
</v-dialog>

<v-btn fixed fab bottom left color="primary" class="" @click="addMedia()"><v-icon>mdi-plus
</v-icon></v-btn>

<v-container class="primary lighten-5">
  <v-row no-gutters >
    <v-col cols="6" align-self="center">
      <v-switch class="mt-0" color="primary" :label="$t('show_clock')"
      v-model="ss.setting.jumbotron_show_clock" hide-details></v-switch>
    </v-col>
    <v-col cols="2">
      <v-text-field single :label="$t('jumbotron_pause')"
      v-model.number="jumbotron_pause" hide-details class="mb3"></v-text-field>
    </v-col>

    <v-col cols="4" align-self="center" class="text-right">
      <v-btn color="primary" small @click="saveSetting()">{{ $t('update') }}</v-btn>
    </v-col>
  </v-row>
</v-container>


<v-divider></v-divider>

<v-container class=" pa-0">
  <v-row dense no-gutters>
    <v-col>
      <v-list dense color="primary lighten-5" v-if="excludedJumbotrons.length > 0">
        <v-list-group prepend-icon="mdi-history" :value="false">
          <template v-slot:activator>
            <v-list-item-title class="body-2">{{ $t('show_history') }}</v-list-item-title>
          </template>

          <template v-for="(jumbotron) in excludedJumbotrons" >
            <v-list-item :key="jumbotron.id" class="px-3">
              <v-list-item-icon @click.stop="editJumbotron(jumbotron)">
                <div :style="($vuetify.breakpoint.xsOnly) ? 'position: relative;width:100px;'
                : 'position: relative;max-width:140px;'"  >
                <v-img v-if="jumbotron.Medium.format == 'image'"
                :src="ss.apiUrl+'/static/images/'
                +jumbotron.Medium.user_id+'/thumb/'+jumbotron.Medium.body"
                :lazy-src="ss.apiUrl+'/static/images/'+jumbotron.Medium.user_id
                +'/thumb/'+jumbotron.Medium.body"  >
              </v-img>

              <v-img v-if="jumbotron.Medium.format == 'video'"
              :src="'https://i.ytimg.com/vi/' +  trimYoutubeId(jumbotron.Medium.body)
              + '/mqdefault.jpg'" :lazy-src="'https://i.ytimg.com/vi/'
              + trimYoutubeId(jumbotron.Medium.body) +'/default.jpg'">
            </v-img>

          </div>
        </v-list-item-icon>
        <v-list-item-content >
          <v-list-item-title class="text-center">
          {{ $t('expired_on') }}</v-list-item-title>

          <v-list-item-subtitle class="text-center">
          {{ $moment(jumbotron.stop).format('DD/MM/YYYY HH:mm') }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon>
            <v-icon color="red" @click="deleteJumbotron(jumbotron.id)">
            mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>

      </v-list-item>
      <v-divider :key="'div-'+jumbotron.id"></v-divider>
    </template>

  </v-list-group>
</v-list>
</v-col>
</v-row>
</v-container>


<v-container>
  <v-progress-linear v-if="loader === true"  :indeterminate="true" class="mt-0 mb-1"
  color="primary" height="30"></v-progress-linear>
  <v-alert v-if="activeJumbotrons.length == 0 && loader === false" type="warning"
  icon="mdi-information-variant" class="mt-3 mb-6">
  {{ $t('no_data') }}
</v-alert>

<v-simple-table v-else>
  <tbody>
    <tr v-for="(jumbotron,idx) in activeJumbotrons" :key="jumbotron.id" >
      <td class="pl-0 pr-2 py-2" @click.stop="editJumbotron(jumbotron)">
        <v-lazy :options="{ threshold: .5 }" transition="fade-transition"
        v-model="isLazyJumbotron" min-height="50">
          <div :style="($vuetify.breakpoint.xsOnly)
          ? 'position: relative;max-width:140px;' : 'position: relative;max-width:280px;'"  >


          <v-img v-if="jumbotron.Medium.format == 'image'"
          :src="ss.apiUrl+'/static/images/'+jumbotron.Medium.user_id
          +'/thumb/'+jumbotron.Medium.body"
          :lazy-src="ss.apiUrl+'/static/images/lazy.png'"
          :aspect-ratio="16/9" contain>
        </v-img>

        <v-img v-if="jumbotron.Medium.format == 'video'"
        :src="'https://i.ytimg.com/vi/' +  trimYoutubeId(jumbotron.Medium.body)
        + '/mqdefault.jpg'" contain :aspect-ratio="16/9"
        :lazy-src="ss.apiUrl+'/static/images/lazy.png'">
      </v-img>

      <div class="absolute-top">
        <div style="background: rgba( 0,0,0,0.4);" class="text-truncate caption
        px-1 yellow--text text--lighten-2 font-weight-medium" >
        {{ jumbotron.Medium.title.substring(0, 1).toUpperCase()
        + jumbotron.Medium.title.substring(1) }}</div>
      </div>

    </div>
  </v-lazy>
</td>
<td class="pl-2 pr-0 text-center">
  <div>
    <v-btn :disabled="idx == 0" fab text small @click = "arrange(idx, 'push')">
      <v-icon >mdi-chevron-double-up</v-icon></v-btn>
      <v-btn :disabled="idx == activeJumbotrons.length-1" fab  text small
      @click = "arrange(idx, 'pull')"> <v-icon >mdi-chevron-double-down</v-icon></v-btn>
      <v-btn fab  text small @click.stop="deleteJumbotron(jumbotron.id)"><v-icon
        color="red">mdi-delete</v-icon></v-btn>

      </div>
      <v-divider></v-divider>
      <div class="grey--text">
        {{ formatDuration(jumbotron.duration) }}
        <v-icon  v-if="jumbotron.MFormat=='video' || jumbotron.Medium.format =='video'"
        color="primary" size="20">
        {{ ( jumbotron.muted ) ? 'mdi-volume-off' : 'mdi-volume-high' }}
      </v-icon>
      <div class="caption">{{ (jumbotron.stop.split(' ')[0] == '2099-12-31')
        ? $t('all_time') : $t('until') + ': '
      + $moment(jumbotron.stop).format('D/M/YY H:m') }}</div>
    </div>
  </td>
</tr>
</tbody>
</v-simple-table>

</v-container>

<v-dialog v-model="dialogMedia" scrollable  persistent :overlay="false"
max-width="500px" transition="dialog-transition" >
<v-card flat tile>
  <v-card-title >
    {{ dialogMediaTitle }} <v-spacer></v-spacer><v-icon @click="closeDialogMedia()">
    mdi-close</v-icon>
  </v-card-title>
  <v-card-text>
    <v-text-field
    class="pt-1 pb-2"
    dense outlined
    :label="$t('type at least 3 char')"
    v-model="ss.search"
    id="search"
    hide-details
    append-icon="mdi-magnify"
    clearable
    ></v-text-field>


    <v-container class="pa-0">
      <v-row dense>

        <v-col cols="12" v-if=" ss.search !== null && filteredMedias.length == 0">
          {{ $t('no_result') }}
        </v-col>
        <v-col cols="6" v-for="media in filteredMedias" :key="media.id">
          <v-lazy :options="{ threshold: .5 }" transition="fade-transition"
          min-height="50" v-model="isLazyMedia">
            <v-card @click="selectItem(media)">
              <div class="">
                <v-img v-if="media.format=='image'"
                :src=" ss.apiUrl+'/static/images/'+media.user_id+'/thumb/'+ media.body"
                :lazy-src="ss.apiUrl+'/static/images/lazy.png'"
                :aspect-ratio="16/9" contain>
              </v-img>

              <v-img v-if="media.format == 'video'" :src="'https://i.ytimg.com/vi/'
              +  trimYoutubeId(media.body) + '/mqdefault.jpg'"
              contain :aspect-ratio="16/9"
              :lazy-src="ss.apiUrl+'/static/images/lazy.png'">
            </v-img>

            <div style="background: rgba( 0,0,0,0.4);" class="absolute-bottom
            text-truncate caption px-1 white--text font-weight-medium" >
              {{ media.title }}
            </div>
          </div>
        </v-card>
      </v-lazy>
    </v-col>
  </v-row>
</v-container>
</v-card-text>

</v-card>
</v-dialog>

</v-container>
</template>

<script>

import { mapState } from 'vuex';

// require('intersection-observer');

export default {
  data() {
    return {
      isLazyJumbotron: false,
      isLazyMedia: false,
      timeOption: 'alltime',
      timeOptions: [{ id: 1, text: this.$i18n.t('all_time'), value: 'alltime' }, { id: 2, text: this.$i18n.t('between'), value: 'between' }],
      loader: true,
      jbSetting: false,
      dialogMedia: false,
      dialogMediaTitle: '',
      dialogMediaSaveBtn: '',

      dialogJumbotron: false,
      dialogJumbotronTitle: '',
      dialogJumbotronSaveBtn: '',

      activeJumbotrons: [],
      excludedJumbotrons: [],

      jumbotron: { Medium: {} },
      medias: [],
      selectMedia: {},

      menuStartDate: false,
      menuStartTime: false,
      startDate: '',
      startTime: '',
      menuStopDate: false,
      menuStopTime: false,
      stopDate: '',
      stopTime: '',

      jumbotron_pause: '',

      transitions: [
        { value: 'fade', text: 'Fade' },
        { value: 'slideUp', text: 'Slide Up' },
        { value: 'slideDown', text: 'Slide Down' },
        { value: 'slideLeft', text: 'Slide Left' },
        { value: 'slideRight', text: 'Slide Right' },
        { value: 'zoomIn', text: 'Zoom In' },
        { value: 'zoomOut', text: 'Zoom Out' },
      ],

      remoteLang: localStorage.getItem('remoteLang'),

    };
  },

  created() {
    this.$store.commit('mutate', { property: 'pageTitle', with: this.$i18n.t('jumbotrons') });
    this.getJumbotrons();
    this.getMedias();
    this.jumbotron_pause = this.ss.setting.jumbotron_pause;
  },

  computed: {
    ...mapState({
      ss: (state) => state,
    }),
    startDateFormatted() {
      return this.formatDate(this.startDate);
    },
    stopDateFormatted() {
      return this.formatDate(this.stopDate);
    },

    filteredMedias() {
      if (this.ss.search === null) {
        return this.medias;
      }

      if (this.ss.search.length < 3) {
        return this.medias;
      }
      return this.medias.filter((i) => i.title.toLowerCase()
        .includes(this.ss.search.toLowerCase()));
    },

  },

  methods: {
    getJumbotrons() {
      this.axios.get(`/jumbotrons/user/${this.ss.setting.user_id}`)
        .then((res) => {
          let jbs = [];
          if (this.ss.license === 'pro-se' || this.ss.license === 'demo') {
            jbs = res.data;
          } else {
            jbs = res.data.filter((i) => i.Medium.format === 'image');
          }

          this.activeJumbotrons = jbs.filter((i) => (this.$moment().isSameOrAfter(this.$moment(i.start), 'second') && this.$moment().isSameOrBefore(this.$moment(i.stop), 'second')));
          this.excludedJumbotrons = jbs.filter((i) => this.$moment().isBefore(this.$moment(i.start), 'second') || this.$moment().isAfter(this.$moment(i.stop), 'second'));

          this.loader = false;
        }).catch((err) => {
          this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t(err.response.data.error), value: true, color: 'red' } });
        });
    },

    getMedias() {
      this.axios.get(`/medias/user/${this.ss.setting.user_id}`)
        .then((res) => {
          if (this.ss.license === 'pro-se' || this.ss.license === 'demo') {
            this.medias = res.data.filter((item) => item.format === 'image' || item.format === 'video');
          } else {
            this.medias = res.data.filter((item) => item.format === 'image');
          }
        }).catch((err) => {
          this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t(err.response.data.error), value: true, color: 'red' } });
        });
    },

    timeOptionsChanged() {
      this.stopDate = (this.timeOption === 'alltime') ? '2099-12-31' : this.$moment().add(1, 'month').format('YYYY-MM-DD');
    },

    addMedia() {
      this.dialogMedia = true;
      this.dialogMediaTitle = this.$i18n.t('choose_media');
      this.dialogMediaSaveBtn = this.$i18n.t('save');
      this.jumbotron.transition = 'fade';
    },

    closeDialogJumbotron() {
      this.$refs.plyr = null;
      this.jumbotron = { id: null, Medium: { body: '', format: '' } };
      this.dialogJumbotron = false;
      this.startDate = '';
      this.startTime = '';
      this.stopDate = '';
      this.stopTime = '';
      this.timeOption = 'alltime';
    },

    selectItem(media) {
      this.dialogJumbotron = true;
      this.closeDialogMedia();
      this.dialogJumbotronSaveBtn = this.$i18n.t('save');
      this.dialogJumbotronTitle = this.$i18n.t('new_jumbotron');
      this.jumbotron.media_id = media.id;
      this.jumbotron.MFormat = media.format;
      this.jumbotron.MUser_id = media.user_id;
      this.jumbotron.MBody = media.body;
      this.jumbotron.duration = media.duration;
      this.startDate = this.$moment().format('YYYY-MM-DD');
      this.startTime = '00:00';
      this.stopDate = '2099-12-31';
      this.stopTime = '23:59';
    },

    closeDialogMedia() {
      this.ss.search = null;
      this.dialogMedia = false;
    },

    editJumbotron(item) {
      this.jumbotron = item;
      [this.startDate] = item.start.split(' ');
      this.startTime = item.start.split(' ')[1].slice(0, -3);
      [this.stopDate] = item.stop.split(' ');
      this.stopTime = item.stop.split(' ')[1].slice(0, -3);
      this.dialogJumbotron = true;
      this.dialogJumbotronSaveBtn = this.$i18n.t('update');
      this.dialogJumbotronTitle = this.$i18n.t('update_jumbotron');

      this.timeOption = (this.stopDate === '2099-12-31') ? 'alltime' : 'between';
    },

    save() {
      this.jumbotron.start = `${this.startDate} ${this.startTime}:00`;
      this.jumbotron.stop = `${this.stopDate} ${this.stopTime}:00`;
      if (!this.jumbotron.id) {
        this.axios.post('/jumbotrons/create', this.jumbotron)
          .then(() => {
            this.getJumbotrons();
            this.$socket.client.emit('reloadJumbotrons', this.ss.setting.license);
            this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t('success'), value: true, color: 'black' } });
            this.closeDialogJumbotron();
          }).catch((err) => {
            this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t(err.response.data.error), value: true, color: 'red' } });
          });
      } else {
        this.axios.patch(`/jumbotrons/${this.jumbotron.id}`, this.jumbotron)
          .then(() => {
            this.getJumbotrons();
            this.$socket.client.emit('reloadJumbotrons', this.ss.setting.license);
            this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t('success'), value: true, color: 'black' } });
            this.closeDialogJumbotron();
          }).catch((err) => {
            this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t(err.response.data.error), value: true, color: 'red' } });
          });
      }
    },

    deleteJumbotron(id) {
      this.$swal({
        title: this.$i18n.t('sure?'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$i18n.t('yes'),
      }).then((result) => {
        if (result.value) {
          this.axios.delete(`/jumbotrons/${id}`)
            .then(() => {
              this.getJumbotrons();
              this.$socket.client.emit('reloadJumbotrons', this.ss.setting.license);
              this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t('success'), value: true, color: 'black' } });
            }).catch((err) => {
              this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t(err.response.data.error), value: true, color: 'red' } });
            });
        }
      });
    },

    saveSetting() {
      if (this.jumbotron_pause === '') {
        this.jumbotron_pause = 0;
      }

      if (typeof this.jumbotron_pause !== 'number') {
        return this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t('jumbotron_pause_required'), value: true, color: 'red' } });
      }

      this.ss.setting.jumbotron_pause = this.jumbotron_pause;

      return this.axios.patch(`/settings/${this.ss.setting.id}`, this.ss.setting)
        .then(() => {
          this.jbSetting = false;
          this.$socket.client.emit('saveSetting', this.ss.setting);
          this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t('success'), value: true, color: 'black' } });
        }).catch((err) => {
          this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t(err.response.data.error), value: true, color: 'red' } });
        });
    },

    showSetting() {
      this.jbSetting = !this.jbSetting;
    },

    arrange(index, to) {
      const push = (to === 'push') ? this.activeJumbotrons[index - 1] : this.activeJumbotrons[index];
      const pull = (to === 'push') ? this.activeJumbotrons[index] : this.activeJumbotrons[index + 1];
      this.axios.post('/jumbotrons/arrange', { push: push.id, pull: pull.id })
        .then(() => {
          this.getJumbotrons();
          this.$socket.client.emit('reloadJumbotrons', this.ss.setting.license);
          this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t('success'), value: true, color: 'black' } });
        }).catch((err) => {
          this.$store.commit('mutate', { property: 'snackbar', with: { text: this.$i18n.t(err.response.data.error), value: true, color: 'red' } });
        });
    },

    formatDate(date) {
      if (!date) return null;
      return this.$moment(date).locale(this.remoteLang).format('L');
    },

    formatDuration(val) {
      const min = Math.floor(val / 60);
      const sec = val - (min * 60);
      return `${min}:${(`000${sec}`).slice(-2)} ${this.$i18n.t('minutes')}`;
    },

    trimYoutubeId(dataUrl) {
      const fa = ['&', '/', '#'];
      if (dataUrl.length === 11 && (fa.includes(dataUrl) === false)) {
        return dataUrl;
      }
      return this.$youtube.getIdFromUrl(dataUrl);
    },

  },

  beforeDestroy() {
    this.ss.search = null;
  },

};
</script>
